<template>
    <div class="flex" style="height: 20px">
        <v-list-item-avatar size="20" class="my-0 mr-1">
            <v-img
                :src="
                    arg.event.extendedProps.teacher.profile_photo_path
                        ? `/api/image-service/20x20/${arg.event.extendedProps.teacher.profile_photo_path}`
                        : arg.event.extendedProps.teacher.profile_photo_url
                "
            ></v-img>
        </v-list-item-avatar>
        <v-list-item-content class="mr-3 font-bold">
            <small>{{ arg.event.title }}</small></v-list-item-content
        >
    </div>
</template>

<script>
export default {
    props: {
        arg: {
            type: Object,
            default: () => {},
        },
    },
};
</script>
